import { CATEGORY_MODEL_CLASS_NAME } from 'models/daos/category/constants'
import { COMMENT_MODEL_CLASS_NAME } from 'models/daos/comment/constants'
import { TAG_MODEL_CLASS_NAME } from 'models/daos/tag/constants'
import { USER_MODEL_CLASS_NAME } from 'models/daos/user/constants'

const ARTICLE_MODEL_CLASS_NAME = 'Article'

const ARTICLE_MODEL_KEY = {
  TITLE: 'title',
  DESCRIPTION: 'description',
  IMG: 'img',
  SHARE_IMG: 'shareImg',
  SLUG: 'slug',
  PUBLISHED_AT: 'publishedAt',
  FEATURED_AT: 'featuredAt',
  CONTENT: 'content',
  COMMENT_COUNT: 'commentCount',
  CATEGORIES: 'categories',
  COMMENTS: 'comments',
  RECOMMENDED: 'recommended',
  TAGS: 'tags',
  USER: 'user'
}

const ARTICLE_MODEL_KEY_POINTER = ARTICLE_MODEL_KEY.SLUG
const ARTICLE_MODEL_VALIDATOR = {
  [ARTICLE_MODEL_KEY.TITLE]: [
    50,
    60
  ],
  // [ARTICLE_MODEL_KEY.DESCRIPTION]: [
  //   120,
  //   160
  // ],
  // [ARTICLE_MODEL_KEY.TAGS]: [
  //   3,
  //   20
  // ],
  [ARTICLE_MODEL_KEY.SLUG]: [
    3,
    12
  ],
  [ARTICLE_MODEL_KEY.CATEGORIES]: [
    1,
    2
  ]
  // [ARTICLE_MODEL_KEY.RECOMMENDED]: [
  //   0,
  //   10
  // ]
}

const ARTICLE_MODEL_PLACEHOLDER = {
  [ARTICLE_MODEL_KEY.TITLE]: 'Example Article',
  [ARTICLE_MODEL_KEY.DESCRIPTION]: 'This is an example.',
  // [ARTICLE_MODEL_KEY.TAGS]: 'Article, Happiness, Joy',
  [ARTICLE_MODEL_KEY.IMG]: 'https//cdn.gymaholic.co/articles/fitness/1-article-example/1-article-example.jpg',
  [ARTICLE_MODEL_KEY.SHARE_IMG]: 'https//cdn.gymaholic.co/articles/fitness/1-article-example/share-article-example-1.jpg',
  [ARTICLE_MODEL_KEY.SLUG]: 'article-example',
  [ARTICLE_MODEL_KEY.CATEGORIES]: 'fitness',
  // [ARTICLE_MODEL_KEY.RECOMMENDED]: '10, 5, (article id)',
  [ARTICLE_MODEL_KEY.PUBLISHED_AT]: false,
  [ARTICLE_MODEL_KEY.FEATURED_AT]: false,
  [ARTICLE_MODEL_KEY.CONTENT]: '# Here\'s where the magic happen'
}

/**
 * A mapping of property key to className.
 * @type {Object}
 */
const ARTICLE_MODEL_ASSOCIATION = {
  [ARTICLE_MODEL_KEY.CATEGORIES]: CATEGORY_MODEL_CLASS_NAME,
  [ARTICLE_MODEL_KEY.COMMENTS]: COMMENT_MODEL_CLASS_NAME,
  [ARTICLE_MODEL_KEY.RECOMMENDED]: 'Article',
  [ARTICLE_MODEL_KEY.TAGS]: TAG_MODEL_CLASS_NAME,
  [ARTICLE_MODEL_KEY.USER]: USER_MODEL_CLASS_NAME
}

/**
 * A list of association keys loaded separately.
 * @type {String[]}
 */
const ARTICLES_MODEL_ASSOCIATIONS_ISOLATE = [
  ARTICLE_MODEL_KEY.COMMENTS
]
export {
  ARTICLE_MODEL_CLASS_NAME,
  ARTICLE_MODEL_KEY,
  ARTICLE_MODEL_KEY_POINTER,
  ARTICLE_MODEL_VALIDATOR,
  ARTICLE_MODEL_PLACEHOLDER,
  ARTICLE_MODEL_ASSOCIATION,
  ARTICLES_MODEL_ASSOCIATIONS_ISOLATE
}
